import { cx } from '@linaria/core';
import { pm2ConfigStore } from '@pm2/store';
import { placeholder } from './empty-image.style.js';
import { jsx } from 'react/jsx-runtime';

function EmptyImageComponent() {
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  return /*#__PURE__*/jsx("div", {
    className: cx("gEmptyImage", placeholder, audience)
  });
}

export { EmptyImageComponent };
//# sourceMappingURL=empty-image.js.map
